// AUTO-GENERATED SQL Builder (V40 Final) for BookingMilestone
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingMilestoneSql {
  private ast = new SqlAst('BookingMilestone', 'bookingMilestone');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public label: SqlField;
  public pct: SqlField;
  public amount: SqlField;
  public releasedDate: SqlField;
  public dueDate: SqlField;
  public sortOrder: SqlField;
  public mode: SqlField;
  public value: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingMilestoneShareList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingMilestone', 'guid', '', 'id', 'bookingMilestone_guid');
    this.bookingId = new SqlField('bookingMilestone', 'bookingId', 'booking', 'id', 'bookingMilestone_booking');
    this.label = new SqlField('bookingMilestone', 'label', '', 'id', 'bookingMilestone_label');
    this.pct = new SqlField('bookingMilestone', 'pct', '', 'id', 'bookingMilestone_pct');
    this.amount = new SqlField('bookingMilestone', 'amount', '', 'id', 'bookingMilestone_amount');
    this.releasedDate = new SqlField('bookingMilestone', 'releasedDate', '', 'id', 'bookingMilestone_releasedDate');
    this.dueDate = new SqlField('bookingMilestone', 'dueDate', '', 'id', 'bookingMilestone_dueDate');
    this.sortOrder = new SqlField('bookingMilestone', 'sortOrder', '', 'id', 'bookingMilestone_sortOrder');
    this.mode = new SqlField('bookingMilestone', 'mode', '', 'id', 'bookingMilestone_mode');
    this.value = new SqlField('bookingMilestone', 'value', '', 'id', 'bookingMilestone_value');
    this.booking = createNavHybrid('bookingMilestone', 'bookingMilestone_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingMilestone', 'bookingMilestone_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingMilestone', 'bookingMilestone_updatedByUser', 'User');
    this.bookingMilestoneShareList = createNavHybrid('bookingMilestone', 'bookingMilestone_bookingMilestoneShareList', 'BookingMilestoneShare');
    this.id = new SqlField('bookingMilestone', 'id', '', 'id', 'bookingMilestone_id');
    this.isDeleted = new SqlField('bookingMilestone', 'isDeleted', '', 'id', 'bookingMilestone_isDeleted');
    this.createdBy = new SqlField('bookingMilestone', 'createdBy', '', 'id', 'bookingMilestone_createdBy');
    this.createdDate = new SqlField('bookingMilestone', 'createdDate', '', 'id', 'bookingMilestone_createdDate');
    this.updatedBy = new SqlField('bookingMilestone', 'updatedBy', '', 'id', 'bookingMilestone_updatedBy');
    this.updatedDate = new SqlField('bookingMilestone', 'updatedDate', '', 'id', 'bookingMilestone_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingMilestoneSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingMilestoneSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingMilestoneSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingMilestoneSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingMilestoneSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
